export const getBookIndexFromPage = (page, metadata) => {
    for (var i = metadata.books.length - 1; i >= 0; i--) {
        if (page >= metadata.books[i].firstPage) {
            return i;
        }
    }
    return 0; // default to book one i guess?
}